import { KeyboardEvent } from 'react';

/**
 * Determine if a message should be sent based on keyboard event
 * @param event The keyboard event
 * @param isComposing Whether IME composition is in progress
 * @returns Whether the message should be sent
 */
export const shouldSendMessage = (event: KeyboardEvent<HTMLTextAreaElement>, isComposing: boolean): boolean => {
  return event.key === 'Enter' && !event.shiftKey && !isComposing;
};

/**
 * Get and clear the input value from a textarea element
 * @param element The textarea element
 * @returns The trimmed input value, or null if the input is invalid
 */
export const getAndClearInput = (element: HTMLTextAreaElement | null): string | null => {
  if (!element) return null;

  const value = element.value.trim();
  if (!value) return null;

  element.value = '';
  element.style.height = 'auto';

  return value;
};
